import { useContext, useState, useEffect } from 'react';
import B2BInput from '../../components/common/B2BInput';
import "./MappedProductDimentions.css";
import { MappedProductContext } from '../../Context/MappedProductContext';
const MappedProductDimentions = ({ vendorId }) => {
    const { product, handleChange, inputError, setProduct, setInputError } = useContext(MappedProductContext);
    const [width, setWidth] = useState({
        inches: '',
        centimeter: '',
        meter: '',
    });
    const [uom, setUom] = useState({
        kg: '',
        meter_per_roll: '',
        yard_per_roll: '',
    });


    useEffect(() => {
        if (product.metrics?.width) {
            updateWidthValues(product.metrics.width);
        }
    }, [product?.metrics?.weight, product.metrics?.width]);

    const updateWidthValues = (widthValue) => {
        let newWidth = {};
        newWidth.centimeter = (widthValue * 2.54).toFixed(2);
        newWidth.meter = (widthValue * 0.0254).toFixed(2);
        const weight = product.metrics?.weight || 1;
        const meterPerKgValue = 1000 / (newWidth.meter * weight);
        newWidth.meter_per_kg = isNaN(meterPerKgValue) ? '' : meterPerKgValue.toFixed(2);
        setWidth(newWidth);

        setProduct((prevState) => ({
            ...prevState,
            metrics: {
                ...prevState.metrics,
                meterPerKg: isNaN(meterPerKgValue) ? '' : meterPerKgValue.toFixed(2),
            },
        }));

        if (product.otherInformation?.kilogram) {
            const kgValue = product.otherInformation.kilogram;
            const meters = kgValue * newWidth.meter_per_kg;
            const yards = meters * 1.094;

            setUom((prevUom) => ({
                ...prevUom,
                kg: kgValue.toString(),
                meter_per_roll: meters.toFixed(2),
                yard_per_roll: yards.toFixed(2),
            }));
        }
    };

    const handleDimensionChange = (event, unit, errorName) => {
        let newValue = event.target.value;
        setInputError((prev) => ({
            ...prev,
            [errorName]: ""
        }))
        if (newValue === '') {
            setWidth({ centimeter: '', meter: '', meter_per_kg: '' });
            setProduct((prevState) => ({
                ...prevState,
                metrics: {
                    ...prevState.metrics,
                    width: '',
                    meterPerKg: ''
                }
            }));
            return;
        }
        newValue = parseFloat(newValue) || 0;

        let newWidth = { ...width };

        if (unit === 'inches') {
            newWidth.inches = newValue;
            newWidth.centimeter = (newValue * 2.54).toFixed(2);
            newWidth.meter = (newValue * 0.0254).toFixed(2);
        } else if (unit === 'centimeter') {
            newWidth.centimeter = newValue;
            newWidth.inches = (newValue / 2.54).toFixed(2);
            newWidth.meter = (newValue * 0.01).toFixed(2);
        } else if (unit === 'meter') {
            newWidth.meter = newValue;
            newWidth.inches = (newValue / 0.0254).toFixed(2);
            newWidth.centimeter = (newValue * 100).toFixed(2);
        }

        const weight = product.metrics?.weight || 1;
        const newMeterPerKg = 1000 / (newWidth.meter * weight);
        newWidth.meter_per_kg = isNaN(newMeterPerKg) ? '' : newMeterPerKg.toFixed(2);

        setWidth(newWidth);

        setProduct((prevState) => ({
            ...prevState,
            metrics: {
                ...prevState.metrics,
                width: newWidth.inches ? parseFloat(newWidth.inches) : prevState.metrics.width,
                meterPerKg: newWidth.meter_per_kg ? parseFloat(newWidth.meter_per_kg) : prevState.metrics.meterPerKg
            }
        }));
    };

    const handleWeightChange = (event) => {
        const newWeight = parseFloat(event.target.value);
        handleChange(event, 'metrics.weight', 'weightErrorMessage');
        const meterValue = width.meter;
        const newMeterPerKg = 1000 / (meterValue * newWeight);
        setWidth((prevWidth) => ({
            ...prevWidth,
            meter_per_kg: isNaN(newMeterPerKg) ? '' : newMeterPerKg.toFixed(2),
        }));
    };


    const handleUOMChange = (event, uomType) => {
        const newValue = event.target.value;
        setUom((prevUom) => {
            let updatedUom = { ...prevUom, [uomType]: newValue };
            if (uomType === 'kg') {
                const kgValue = parseFloat(newValue);
                const meters = kgValue * width.meter_per_kg;
                updatedUom.meter_per_roll = meters.toFixed(2);

                const yards = meters * 1.094;
                updatedUom.yard_per_roll = yards.toFixed(2);
                setProduct((prevState) => ({
                    ...prevState,
                    otherInformation: {
                        ...prevState.otherInformation,
                        kilogram: kgValue || null,
                    },
                }));
            }
            return updatedUom;
        });
    };

    const dimension_json = [
        {
            label: "Width",
            fields: [
                {
                    unit: "inches",
                    type: "number",
                    placeholder: "In inches",
                    value: product.metrics?.width || '',
                    onChange: (event) => handleDimensionChange(event, "inches", "widthErrorMessage"),
                    error: inputError?.widthErrorMessage || '',
                },
                {
                    unit: "centimeter",
                    type: "number",
                    placeholder: "In cm",
                    value: width.centimeter,
                    onChange: (event) => handleDimensionChange(event, "centimeter", "widthErrorMessage"),
                    error: inputError?.widthErrorMessage || '',
                },
                {
                    unit: "meter",
                    type: "number",
                    placeholder: "In m",
                    value: width.meter,
                    onChange: (event) => handleDimensionChange(event, "meter", "widthErrorMessage"),
                    error: inputError?.widthErrorMessage || '',
                    disable: true
                },
            ]
        },
        {
            label: "Weight",
            unit: 'gsm',
            type: "number",
            placeholder: "In gsm",
            value: product.metrics?.weight || '',
            onChange: handleWeightChange,
            error: inputError?.weightErrorMessage || ''
        },
        {
            label: "Meter/Kg",
            unit: 'm/kg',
            type: "number",
            placeholder: "Meter/Kg",
            value: width.meter_per_kg,
            onChange: (event) => handleDimensionChange(event, "m/kg"),
            disable: true
        }
    ];

    const uom_json = [
        {
            label: product.otherInformation.unitOfMeasures.isKg === true ? "Std.kg" : product.otherInformation.unitOfMeasures.isMeter === true ? "Std.Meter" : product.otherInformation.unitOfMeasures.isYard === true ? "Std.Yard" : '',
            type: "number",
            placeholder: product.otherInformation.unitOfMeasures.isKg === true ? "In kg" : product.otherInformation.unitOfMeasures.isMeter === true ? "In Meter" : product.otherInformation.unitOfMeasures.isYard === true ? "In Yard" : '',
            value: uom.kg,
            onChange: (event) => handleUOMChange(event, 'kg'),
            disable: false,
            error: inputError?.standardKgErrorMessage || ''
        },
        // {
        //     label: "meter/roll",
        //     type: "number",
        //     placeholder: "In m/roll",
        //     value: uom.meter_per_roll,
        //     onChange: (event) => handleUOMChange(event, 'meter/roll'),
        //     disable: true,
        // },
        // {
        //     label: "yard/roll",
        //     type: "number",
        //     placeholder: "In y/roll",
        //     value: uom.yard_per_roll,
        //     onChange: (event) => handleUOMChange(event, 'yard/roll'),
        //     disable: true,
        // },
        {
            label: "Cone Weight",
            type: "text",
            placeholder: "In grm",
            value: product?.otherInformation?.coneWeight * 1000 || '',
            onChange: (event) => setProduct(prev => ({
                ...prev,
                otherInformation: {
                    ...prev.otherInformation,
                    coneWeight: event.target.value / 1000
                }
            })),
            disable: product?.otherInformation?.unitOfMeasures?.isKg === false,
        },
    ];

    return (
        <form className='form-container' style={{ display: 'flex', flexDirection: "column" }}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
               <h1 style={{ marginBottom: '1rem' ,fontSize:'18px',fontWeight:'900'}}>Dimension</h1>
                <div className='dimensions-grid-dim' >
                    {dimension_json.map((field, index) => (
                        <div key={index} style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                            {/* <label style={{ fontSize: '16px', fontWeight: '800' }}>
                                {field.label}
                                <span className="error-message"> *</span>
                            </label> */}
                            {field.label === 'Width' ? (
                                <div style={{ display: 'flex', gap: '1rem' }}>
                                    {field.fields.map((subField, subIndex) => (
                                        <B2BInput
                                            key={subIndex}
                                            label={subField.unit}
                                            value={subField.value}
                                            type={subField.type}
                                            required
                                            placeholder={subField.placeholder}
                                            onChange={subField.onChange}
                                            error={subField.error || ''}
                                            style={{ width: '6rem' }}
                                            disabled={true}
                                            withAsterisk={false}
                                        />
                                    ))}
                                </div>
                            ) : (
                                <B2BInput
                                    value={field.value}
                                    label={field.unit}
                                    type={field.type}
                                    required
                                    placeholder={field.placeholder}
                                    onChange={field.onChange}
                                    error={field.error}
                                    className='input-textField'
                                    disabled={true}
                                    withAsterisk={false}
                                />
                            )}
                        </div>
                    ))}
                </div>
            </div>
            <div>
                <h1 style={{ marginBottom: '1rem' ,fontSize:'18px',fontWeight:'900'}}> Unit Of Measurement</h1>
                <div className='std-cone-weight' style={{ display: 'flex', gap: '16px' }}>
                    {
                        uom_json.map((item, index) => (
                            <div key={index}>
                                <label style={{ fontSize: '16px', fontWeight: '500' }}>
                                    {item.label}
                                    {(item.label === 'Std.kg' || item.label === 'Std.Meter') && <span className="error-message"> *</span>}
                                </label>

                                <B2BInput
                                    value={item.value}
                                    type={item.type}
                                    required
                                    placeholder={item.placeholder}
                                    onChange={item.onChange}
                                    className='input-textField'
                                    disabled={true}
                                    error={item.error}
                                />
                            </div>
                        ))
                    }
                </div>
            </div>
        </form>
    );
};

export default MappedProductDimentions;